<form class="wrapper" #formRef="ngForm">
	<ng-container *ngIf="entity">
		<h2 *ngIf="entity?.id">{{ 'EDIT_' + label | translate }} </h2>
		<h2 *ngIf="!entity?.id">{{ 'CREATE_' + label | translate }} </h2>
		<div class="status">
			<bb-status *ngIf="entity" [(ngModel)]="entity.status" name="status" [labelOn]="'ACTIVE' | translate" [labelOff]="'INACTIVE' | translate" [valueOff]="'inactive'" [valueOn]="'active'" ></bb-status>
		</div>
		<bb-form-element [form]="form" [label]="'SOURCE' | translate">
			<bb-text [(ngModel)]="entity.src" name="source"></bb-text>
		</bb-form-element>
		<div class="container">
			<div class="leftSide">
				<bb-form-element [form]="form" [label]="'ASSET_TYPE' | translate">
					<bb-entity-selector
						[(ngModel)]="entity.mediatype"
						[options]="mediaTypeOptions"
						[name]="label"
						[extendable]="false"
					></bb-entity-selector>
				</bb-form-element>
				<bb-form-element *ngIf="mediaclipType !== 'document'" [form]="form" [label]="'BITRATE' | translate" [postLabel]="'KBPS' | translate">
					<bb-text [(ngModel)]="entity.bandwidth" name="bitrate"></bb-text>
				</bb-form-element>	
			</div>
			<div *ngIf="mediaclipType === 'video'" class="rightSide">
				<bb-form-element [form]="form" [label]="'WIDTH' | translate" [postLabel]="'PX' | translate">
					<bb-text [(ngModel)]="entity.width" name="width"></bb-text>
				</bb-form-element>
				<bb-form-element [form]="form" [label]="'HEIGHT' | translate" [postLabel]="'PX' | translate">
					<bb-text [(ngModel)]="entity.height" name="height"></bb-text>
				</bb-form-element>
			</div>
		</div>
	</ng-container>
</form>
<div class="actions" *ngIf="entity && form">
	<button class="button" (click)="delete()" [hidden]="!entity?.id"><i class="fa fa-trash"></i> {{ 'DELETE' | translate }}</button>
	<button class="button submit" (click)="saveQuickEdit()"><i class="fa fa-floppy-o"></i> {{ 'SAVE' || translate }}</button>
	<button class="button cancel" (click)="onCancelClick()"><i class="fa fa-ban"></i> {{ 'CANCEL' | translate }}</button>
</div>
